
import React, { Component } from "react";
import { connect } from "react-redux";
import '../../../../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
import '../../../../../../Assets/EnsembleStyles/ViewTenantDetails.css';
import { Button } from 'reactstrap';
// import { GetZonesList } from '../../../../../../action/ZonesAction';
import Currencies from '../../../../../../Resources/Currencies';
import Conversions from '../../../../../../Resources/Conversions';

class ViewAfterHours extends Component {


constructor(props){
  super(props);
  this.state = {
    TenantID :this.props.AfterHours_response.tenantId,
    RatePerHour :this.props.AfterHours_response.ratePerHour,
    MinmumAfterHour :this.props.AfterHours_response.minmumAfterHour,
    RounderHours :this.props.AfterHours_response.rounderHours,
    Zones :this.props.AfterHours_response.zones,
    FacilitySetup:this.props.AfterHours_response.facilitysetup,
    HasZoneRate:this.props.AfterHours_response.hasZoneRate,
    tenant_zones: this.props.TenantZones_response,
    currencyId:this.props.CompanyInformation_response.currencyId
  };
}

componentWillReceiveProps(nextProps) {
 
if(this.props !== nextProps) {
  this.setState({  
    TenantID : nextProps.AfterHours_response.tenantId,
    RatePerHour :nextProps.AfterHours_response.ratePerHour,
    MinmumAfterHour :Conversions.formatNumberAHrs(nextProps.UserPreference_response,nextProps.AfterHours_response.minmumAfterHour),
    RounderHours :Conversions.formatNumberAHrs(nextProps.UserPreference_response,nextProps.AfterHours_response.rounderHours),
    Zones :nextProps.AfterHours_response.zones,
    FacilitySetup:nextProps.AfterHours_response.facilitysetup,
    HasZoneRate:nextProps.AfterHours_response.hasZoneRate,
    tenant_zones: nextProps.TenantZones_response,
    currencyId: nextProps.CompanyInformation_response.currencyId
    });
}
}


    render(AfterHours_response,TenantZones_response,CompanyInformation_response,getLabels,UserPreference_response,UserCanEdit) {

        let ZoneRate = ""; let EmailDisabled = "",sendToAdditionalRecipient,sendToRequestedEmployee; 
        let EmailToEmployee = "", AddtionalReceipients = "", EmailText ="";
        let label = this.props.getLabels;
        let PreferedDateFormat = this.props.UserPreference_response;
        let lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;
      
        if(this.state.HasZoneRate){
          if(this.state.tenant_zones !== undefined && this.state.tenant_zones !== null){
          ZoneRate = this.state.tenant_zones.map(el => {
            var l_SelectedZone = this.state.Zones.filter(xl => (xl.zoneId === el.zoneId))[0];
            var l_ZoneRate = l_SelectedZone !== undefined ? l_SelectedZone.rate : "50.00";
            return <div className="viewlabel"><label className="leftviewlabel">{el.zoneName}</label>
            <label className="rightviewlabel">{Currencies.CurrencySymbol(this.state.currencyId) + " " + Conversions.formatNumber(PreferedDateFormat,l_ZoneRate) }</label></div>
          });
          }
        }

        if(this.state.FacilitySetup != null){
          if(this.state.FacilitySetup.sendToAdditionalRecipient){
            AddtionalReceipients = this.state.FacilitySetup.toEmailAddress.map(el => (
              <div className="viewlabel"><label className="leftviewlabel"></label><label className="rightviewlabel">{el}</label></div>
            ));
          }
        }
        
         if(this.state.FacilitySetup != null){
         sendToAdditionalRecipient = this.state.FacilitySetup.sendToAdditionalRecipient;
         sendToRequestedEmployee = this.state.FacilitySetup.sendToRequestedEmployee;
         }

        EmailDisabled = <div className="viewlabel"  ><label className="leftviewlabel">{label['TenantFacility.DisableStatus.Text']}</label></div>
        EmailToEmployee = <div className="viewlabel"  ><label className="leftviewlabel">{label['TenantFacility.EnableStatus.Text']}</label> <label className="rightviewlabel">{label['TenantFacility.SendEmail.Text']}</label></div>
       
        if(!sendToAdditionalRecipient && !sendToRequestedEmployee){
          EmailText = EmailDisabled;
        }
        else if(!sendToAdditionalRecipient && sendToRequestedEmployee){
          EmailText = EmailToEmployee;
        }     

      return (
        <div className="main_container">
          <div className="buttons_container">
            <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" onClick={this.props.Display}>{label['ManageTenants.Edit.Text']} </Button>
          </div>
          <div className="headinglabel"><p><b>{label['CreateTenant.BillingSetup.Text']}</b></p> </div>
          <div className="viewlabel" ><label className="leftviewlabel">{label['CreateTenant.ViewAfterHoursHourlyRate.Text']}</label>
          {
            (!this.state.HasZoneRate) ? <label className="rightviewlabel">{Currencies.CurrencySymbol(this.state.currencyId) + " " + parseFloat(this.state.RatePerHour).toFixed(2)}</label> : ""
          }
          </div><br/>
          {
           (this.state.HasZoneRate) ? ZoneRate : ""
          }
          <br></br>

          <div className="viewlabel"><label className="leftviewlabel">{label['CreateTenant.MinimumAfterHourschange.Text']}</label> <label className="rightviewlabel">{this.state.MinmumAfterHour === "0.0" || this.state.MinmumAfterHour === 0 || this.state.MinmumAfterHour === null? "None" : this.state.MinmumAfterHour + " Hours"}  </label></div>
          <div className="viewlabel"><label className="leftviewlabel">{label['CreateTenant.BilledItem.Text']}</label> <label className="rightviewlabel">{this.state.RounderHours === "0.0" || this.state.RounderHours === 0 || this.state.RounderHours === null? "None" : this.state.RounderHours + " Hours"} </label></div>
          <br></br>
          
          <div className="headinglabel"><p><b>{label['AddEditSubGroups.PageHeader.FacilityRequest.Text']}</b></p> </div>
          {
           (sendToAdditionalRecipient && sendToRequestedEmployee) ? 
          <div className="viewlabel"  ><label className="leftviewlabel">{label['TenantFacility.EnableStatus.Text']}</label><label className="rightviewlabel">{label['TenantFacility.SendEmail.Text']}</label> <label className="rightviewlabel">{label['TenantFacility.Option3.Text']} </label></div>
          : ((sendToAdditionalRecipient && !sendToRequestedEmployee) ?  <div className="viewlabel"  ><label className="leftviewlabel">E-mail notifications Enabled</label><label className="rightviewlabel">{label['TenantFacility.Option3.Text']} </label></div> : EmailText )
          } 
           {AddtionalReceipients}
          
        </div>

      );
    }
    }


    const mapStateToProps = state => {
      return {
        AfterHours_response: state.ViewtenantsRootReducer.AfterHours,
        CompanyInformation_response: state.ViewtenantsRootReducer.CompanyInformation,
        TenantZones_response: state.ViewtenantsRootReducer.TenantZones,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        UserCanEdit: state.authService.HasApplicationFullAcess
      };
    };
    
    
    export default connect(mapStateToProps, null)(ViewAfterHours);







